export default "__VITE_ASSET__7d7dfd22__"